import { useLingui } from '@lingui/react/macro';
import { isDefined } from 'app-shared/utils';
import { useMatch } from 'react-router-dom';

import { CurrentUserMenu } from '@/navigation/components/CurrentUserMenu';
import { MainNavigation } from '@/navigation/components/MainNavigation';
import { SettingsNavigation } from '@/navigation/components/SettingsNavigation';
import { WorkspaceSwitcher } from '@/navigation/components/WorkspaceSwitcher';
import { SETTINGS_NAVIGATION_ITEM } from '@/navigation/constants/SettingsNavigationItem';
import { SETTINGS_ROOT_PATH } from '@/settings/constants/SettingsRootPath';
import { NavigationDrawer } from '@/ui/layout/navigation-drawer/components/NavigationDrawer';
import { NavigationDrawerItem } from '@/ui/layout/navigation-drawer/components/NavigationDrawerItem';

export const AppNavigationDrawer = () => {
  const { i18n } = useLingui();
  const isInSettings = isDefined(useMatch(`${SETTINGS_ROOT_PATH}/*`));

  return (
    <NavigationDrawer
      header={<WorkspaceSwitcher />}
      footer={
        <>
          <NavigationDrawerItem
            label={i18n._(SETTINGS_NAVIGATION_ITEM.label)}
            Icon={SETTINGS_NAVIGATION_ITEM.Icon}
            to={SETTINGS_NAVIGATION_ITEM.path}
          />
          <CurrentUserMenu />
        </>
      }
    >
      {isInSettings ? <SettingsNavigation /> : <MainNavigation />}
    </NavigationDrawer>
  );
};
